import type { AppVariantConfig } from '@shared/app/variant';
import { nb } from '@oslo/i18n/nb';
import { en } from './i18n/en';

export const osloCircularFastTrackVariantConfig: AppVariantConfig = {
  variant: 'oslo-circular-fast-track',
  locale: en.meta.locale,
  messages: en,
  fallbackMessages: nb,
  themeClassName: 'theme-oslo-circular-fast-track',
};
